import { Column } from 'src/model';

export const contactColumnList: Array<Column> = [
  {
    id: 'fn',
    title: 'Contact Name',
    checked: true,
    field: 'firstName',
    width: 200,
    disabled: true,
  },
  {
    id: 'an',
    title: 'Account Name',
    checked: true,
    field: 'name',
    width: 200,
    disabled: true,
  },
  {
    id: 'de',
    title: 'Department',
    checked: true,
    field: 'Department',
    width: 200,
  },
  {
    id: 'jt',
    title: 'Job Title',
    checked: true,
    field: 'JobTitle',
    width: 200,
  },
  {
    id: 'dg',
    title: 'Seniority',
    checked: true,
    field: 'Seniority',
    width: 200,
  },
  {
    id: 'in',
    title: 'Intent Score',
    checked: true,
    field: 'Intent Score',
    width: 200,
  },
  {
    id: 'im',
    title: 'Intent Topics',
    checked: true,
    field: 'Intent Topics',
    width: 200,
  },
  {
    id: 'li',
    title: 'List Name',
    checked: true,
    field: 'Tags',
    width: 200,
  },
  {
    id: 'id',
    title: 'Industry',
    checked: true,
    field: 'Industry',
    width: 200,
  },
  {
    id: 'hq',
    title: 'Company HQ',
    checked: false,
    field: 'CompanyHQ',
    width: 200,
  },
  {
    id: 'cr',
    title: 'Company Region',
    checked: false,
    field: 'CompanyRegion',
    width: 200,
  },
  {
    id: 'rv',
    title: 'Revenue',
    checked: true,
    field: 'Revenue',
    width: 200,
  },

  {
    id: 'tf',
    title: 'Total Funding Amount',
    checked: true,
    field: 'TotalFundingAmount',
    width: 200,
  },
  {
    id: 'fa',
    title: 'Latest Funding Amount',
    checked: true,
    field: 'LatestFundingAmount',
    width: 200,
  },
  {
    id: 'fs',
    title: 'Latest Funding Stage',
    checked: false,
    field: 'LatestFundingStage',
    width: 200,
  },
  {
    id: 'lfd',
    title: 'Latest Funding Date',
    checked: false,
    field: 'Latest Funding Date',
    width: 200,
  },
  {
    id: 'ne',
    title: 'Employee Count',
    checked: true,
    field: 'NoOfEmployees',
    width: 200,
  },
  {
    id: 'jo',
    title: 'Job Openings',
    checked: false,
    field: 'JobOpenings',
    width: 200,
  },
  {
    id: 'ad',
    title: 'Address',
    checked: false,
    field: 'Address',
    width: 400,
  },
  {
    id: 'ci',
    title: 'City',
    checked: false,
    field: 'City',
    width: 200,
  },
  {
    id: 'st',
    title: 'State',
    checked: false,
    field: 'State',
    width: 200,
  },
  {
    id: 'co',
    title: 'Country',
    checked: true,
    field: 'Country',
    width: 200,
  },
  {
    id: 'ut',
    title: 'Source',
    checked: true,
    field: 'Source',
    width: 200,
  },
  {
    id: 'sf',
    title: 'Source file',
    checked: true,
    field: 'SourceFile',
    width: 200,
  },
  {
    id: 'cs',
    title: 'Campaign Stage',
    checked: true,
    field: 'CampaignStage',
    width: 200,
  },
  {
    id: 'di',
    title: 'Date Inserted at',
    checked: false,
    field: 'DateInsertedAt',
    width: 200,
  },
  {
    id: 'du',
    title: 'Date Updated at',
    checked: false,
    field: 'DateUpdatedAt',
    width: 200,
  },
  {
    id: 've',
    title: 'Verified Email',
    checked: true,
    field: 'EmailSafe',
    width: 200,
  },
  {
    id: 'als',
    title: 'Account Lifecycle Stage',
    checked: false,
    field: 'Account Lifecycle Stage',
    width: 200,
  },
  {
    id: 'acs',
    title: 'Account Status',
    checked: false,
    field: 'Account Status',
    width: 200,
  },
  {
    id: 'pls',
    title: 'Prospect Lifecycle Stage',
    checked: true,
    field: 'Prospect Lifecycle Stage',
    width: 200,
  },
  {
    id: 'ao',
    title: 'Contact Owner',
    checked: true,
    field: 'Owner',
    width: 200,
  },
  // {
  //   id: 'act',
  //   title: 'Action',
  //   checked: true,
  //   field: 'Action',
  //   width: 200,
  //   disabled: true,
  // },
];

export const accountsColumnList: Array<Column> = [
  {
    id: 'cn',
    title: 'Account Name',
    checked: true,
    disabled: true,
    field: 'name',
    width: 200,
  },
  {
    id: 'in',
    title: 'Industry',
    checked: true,
    field: 'Industry',
    width: 200,
  },
  {
    id: 'ch',
    title: 'Company HQ',
    checked: true,
    field: 'CompanyHQ',
    width: 200,
  },
  {
    id: 'nv',
    title: 'Number of visits',
    checked: true,
    field: 'No of Visits',
    width: 200,
  },
  {
    id: 'lvd',
    title: 'Last Visited Date',
    checked: true,
    field: 'Last Visited Date',
    width: 200,
  },

  {
    id: 'cr',
    title: 'Company Region',
    checked: false,
    field: 'CompanyRegion',
    width: 200,
  },
  {
    id: 're',
    title: 'Revenue',
    checked: true,
    field: 'Revenue',
    width: 200,
  },
  {
    id: 'tf',
    title: 'Total Funding Amount',
    checked: true,
    field: 'TotalFundingAmount',
    width: 200,
  },
  {
    id: 'fa',
    title: 'Latest Funding Amount',
    checked: true,
    field: 'LatestFundingAmount',
    width: 200,
  },
  {
    id: 'fs',
    title: 'Latest Funding Stage',
    checked: false,
    field: 'LatestFundingStage',
    width: 200,
  },
  {
    id: 'lfd',
    title: 'Latest Funding Date',
    checked: false,
    field: 'Latest Funding Date',
    width: 200,
  },
  {
    id: 'ne',
    title: 'Employee Count',
    checked: true,
    field: 'NoOfEmployees',
    width: 200,
  },
  {
    id: 'jo',
    title: 'Job Openings',
    checked: false,
    field: 'JobOpenings',
    width: 200,
  },
  {
    id: 'it',
    title: 'Intent Score',
    checked: true,
    field: 'Intent Score',
    width: 200,
  },
  {
    id: 'inm',
    title: 'Intent Topics',
    checked: true,
    field: 'Intent Topics',
    width: 200,
  },
  {
    id: 'ad',
    title: 'Address',
    checked: false,
    field: 'Address',
    width: 400,
  },
  {
    id: 'ci',
    title: 'City',
    checked: false,
    field: 'City',
    width: 200,
  },
  {
    id: 'st',
    title: 'State',
    checked: false,
    field: 'State',
    width: 200,
  },
  {
    id: 'co',
    title: 'Country',
    checked: true,
    field: 'Country',
    width: 200,
  },
  {
    id: 'wp',
    title: 'Phone Number',
    checked: false,
    field: 'CompanyPhoneNumber',
    width: 200,
  },
  {
    id: 'als',
    title: 'Account Lifecycle Stage',
    checked: true,
    field: 'Account Lifecycle Stage',
    width: 200,
  },
  {
    id: 'acs',
    title: 'Account Status',
    checked: true,
    field: 'Account Status',
    width: 200,
  },
  {
    id: 'qs',
    title: 'Qualification',
    checked: true,
    field: 'Qualification',
    width: 100,
  },
  {
    id: 'ao',
    title: 'Account Owner',
    checked: true,
    field: 'Owner',
    width: 200,
  },
  {
    id: 'icpf',
    title: 'Account ICP',
    checked: true,
    field: 'icpFitmentScore',
    disabled: true,
    width: 200,
  },
];

export const websiteColumnList: Array<Column> = [
  {
    id: 'na',
    title: 'Account Name',
    checked: true,
    disabled: true,
    field: 'name',
    width: 200,
  },
  {
    id: 'cv',
    title: 'Contacts revealed',
    checked: true,
    disabled: true,
    field: 'contactVisited',
    width: 200,
  },
  {
    id: 'tv',
    title: 'Number of visits',
    checked: true,
    field: 'noOfHits',
    width: 110,
  },
  {
    id: 'lv',
    title: 'Last Visited date',
    checked: true,
    field: 'lastModifiedDate',
    width: 200,
  },
  {
    id: 'is',
    title: 'Intent Score',
    checked: true,
    field: 'intentScoreString',
    width: 200,
  },
  {
    id: 'it',
    title: 'Intent Topics',
    checked: true,
    field: 'intentNames',
    width: 200,
  },
  {
    id: 'ad',
    title: 'Address',
    checked: false,
    field: 'address',
    width: 200,
  },
  {
    id: 'ci',
    title: 'City',
    checked: true,
    field: 'city',
    width: 200,
  },
  {
    id: 'st',
    title: 'State',
    checked: false,
    field: 'state',
    width: 200,
  },
  {
    id: 'co',
    title: 'Country',
    checked: true,
    field: 'country',
    width: 200,
  },
  {
    id: 'ph',
    title: 'Phone Number',
    checked: false,
    field: 'phoneNo',
    width: 200,
  },
  {
    id: 'ar',
    title: 'Revenue',
    checked: true,
    field: 'annualRevenue',
    width: 200,
  },

  {
    id: 'in',
    title: 'Industry',
    checked: true,
    field: 'industry',
    width: 200,
  },
  {
    id: 'ct',
    title: 'Total Funding Amount',
    checked: true,
    field: 'totalFundingAmountNumeric',
    width: 150,
  },
  {
    id: 'lf',
    title: 'Latest Funding Amount',
    checked: true,
    field: 'latestFundingAmountNumeric',
    width: 200,
  },
  {
    id: 'ls',
    title: 'Latest Funding Stage',
    checked: false,
    field: 'latestFundingStage',
    width: 200,
  },
  {
    id: 'la',
    title: 'Latest Funding Date',
    checked: false,
    field: 'latestFundingDate',
    width: 200,
  },
  {
    id: 'ne',
    title: 'Employee Count',
    checked: true,
    field: 'noOfEmployee',
    width: 200,
  },
];

export const walContactHeaders = [
  {
    primaryKey: 296656,
    title: 'Contact Name',
    field: 'firstName',
    entity: 'website_contact',
    category: 'Contact',
    checked: true,
    disabled: true,
    displayOrder: 1,
    subCategory: null,
  },
  {
    primaryKey: 296659,
    title: 'Account Name',
    field: 'name',
    entity: 'website_contact',
    category: 'Account',
    checked: true,
    disabled: true,
    displayOrder: 2,
    subCategory: null,
  },
  {
    primaryKey: 296658,
    title: 'Number of Visits',
    field: 'noOfHits',
    entity: 'website_contact',
    category: 'Contact',
    checked: true,
    disabled: false,
    displayOrder: 4,
    subCategory: null,
  },

  {
    primaryKey: 296660,
    title: 'Employee Count',
    field: 'noOfEmployee',
    entity: 'website_contact',
    category: 'Account',
    checked: true,
    disabled: false,
    displayOrder: 5,
    subCategory: null,
  },
  {
    primaryKey: 296661,
    title: 'Revenue',
    field: 'annualRevenue',
    entity: 'website_contact',
    category: 'Account',
    checked: true,
    disabled: false,
    displayOrder: 6,
    subCategory: null,
  },
  {
    primaryKey: 296662,
    title: 'Industry',
    field: 'industry',
    entity: 'website_contact',
    category: 'Account',
    checked: true,
    disabled: false,
    displayOrder: 7,
    subCategory: null,
  },
  {
    primaryKey: 296663,
    title: 'Job Title',
    field: 'jobTitle',
    entity: 'website_contact',
    category: 'Contact',
    checked: true,
    disabled: false,
    displayOrder: 8,
    subCategory: null,
  },
  {
    primaryKey: 296664,
    title: 'Department',
    field: 'department',
    entity: 'website_contact',
    category: 'Contact',
    checked: true,
    disabled: false,
    displayOrder: 9,
    subCategory: null,
  },
  {
    primaryKey: 296665,
    title: 'Designation',
    field: 'designation',
    entity: 'website_contact',
    category: 'Contact',
    checked: true,
    disabled: false,
    displayOrder: 10,
    subCategory: null,
  },
  {
    primaryKey: 296666,
    title: 'Last Visit Duration',
    field: 'lastVisitDuration',
    entity: 'website_contact',
    category: 'Website Visit',
    checked: true,
    disabled: false,
    displayOrder: 11,
    subCategory: null,
  },
  {
    primaryKey: 296667,
    title: 'Last Visited Date',
    field: 'lastModifiedDate',
    entity: 'website_contact',
    category: 'Website Visit',
    checked: true,
    disabled: false,
    displayOrder: 12,
    subCategory: null,
    description: 'Data shown in user configured time zone.',
  },
  {
    primaryKey: 296668,
    title: 'Contact Location (Hit Location)',
    field: 'hitLocation',
    entity: 'website_contact',
    category: 'Website Visit',
    checked: true,
    disabled: false,
    displayOrder: 13,
    subCategory: null,
  },
];
